import React from 'react';
import {Header, Breadcrumb, Container,Loader, Dropdown, Divider, Form, Dimmer, TextArea,   Button, Grid,Input, Radio, Image} from 'semantic-ui-react';
import { Link } from "react-router-dom";
import { DatePicker, Space } from 'antd';
//import "antd/dist/antd.css";
import locale from 'antd/es/date-picker/locale/es_ES';
import moment from 'moment';
import dayjs from 'dayjs';
const dateFormat = 'DD/MM/YYYY';


const UsuarioCursoForm=({ id, color, form, onSave,onChange, ajaxCallInProgress, datos, errors={}, strings, permisos, fechas, usuarioCombo, onHandleFile})=>{



	return (
        <Container>
          <Dimmer active={ajaxCallInProgress>0?true:false} inverted>
          		<Loader size='big' inline content={strings?strings["Procesando"]:""}/>
          </Dimmer>

				<Header     dividing>             
					<Header.Content>{strings?strings["UsuarioCurso"]:""}</Header.Content>
				</Header>
			<Grid container>
                <Grid.Row>
                    <Grid.Column >
                        <Form  >          
        
                            <Form.Field  required  error={errors.usuarioId}>
                                      <label  >{strings?strings["usuarioId"]:""}</label>
                                      <Dropdown 
                                            placeholder={strings?strings["usuarioId"]:""} 
                                            name="usuarioId"
                                             fluid 
                                            search 
                                            selection
                                            onChange={onChange}
                                            value={datos.usuarioId}
                                            options={usuarioCombo}/>
                                    </Form.Field>
        
                                            
                            <Form.Field  required  error={errors.nombreCurso}>            
                              <label  >{strings?strings["nombreCurso"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["nombreCurso"]:""} 
                                    name="nombreCurso"
                                    onChange={onChange}
                                    value={datos.nombreCurso}
                                    icon='edit'/>
                            </Form.Field>
                                            
                         
        
                                     
                        <Form.Field  >
                            <label>{strings?strings["constancia"]:""} </label>
                             <Input placeholder='constancia'
                                onChange={onHandleFile}
                                name="constancia"
                                type='file'

                            />        
                            </Form.Field>
        
        
                            <label>{strings?strings["constanciaActual"]:""} </label>    
                            {datos.constanciaImg!=null?    
                                <>
                                <Image  src={datos.constanciaImg} />    

                                </>
                            :
                    
                                ""
        
                            }
        
                            <br/>
        
        
        
                            <Form.Field  required  error={errors.url}>            
                              <label  >{strings?strings["url"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["url"]:""} 
                                    name="url"
                                    onChange={onChange}
                                    value={datos.url}
                                    icon='edit'/>
                            </Form.Field>
                                                  
                            <label>{strings?strings["fecha"]:""} </label>
                            <DatePicker bordered={false}                  
                                onChange={(dates, dateStrings)=>fechas(dates, dateStrings)} 
                                locale={locale} 
                                size="large" 
                                value={dayjs(datos.fechaCurso, dateFormat)}
                                allowClear={false}
                                format={dateFormat} /> 
        
                                                                        
                            <Divider hidden/>
							  <Grid centered>
                            <Button.Group  >
                                <Link to="/usuariocursos">
                                    <Button  
										>{strings?strings["regresar"]:""}</Button>
                                </Link>
                                <Button.Or text=" "></Button.Or>
                                <Button  color="black"
                                    onClick={onSave}>{strings?strings["guardar"]:""}
								 </Button>
                              </Button.Group>
                            </Grid>
                           <br/>
                        </Form>
                    </Grid.Column>
                </Grid.Row>
                
            
            </Grid>
        
        </Container>
	);
};



export default UsuarioCursoForm;